// Options Actions
export const FETCH_PRACTICE_REQUEST = "FETCH_PRACTICE_REQUEST";
export const FETCH_PRACTICE_SUCCESS = "FETCH_PRACTICE_SUCCESS";
export const FETCH_PRACTICE_ERROR = "FETCH_PRACTICE_ERROR";

export const PRACTICE_DETAIL_REQUEST = "PRACTICE_DETAIL_REQUEST";
export const PRACTICE_DETAIL_SUCCESS = "PRACTICE_DETAIL_SUCCESS";
export const PRACTICE_DETAIL_ERROR = "PRACTICE_DETAIL_ERROR";
